import React from 'react';
import Seo from '../components/Seo';
import { Link } from 'react-router-dom';
// Typeform embed re-enabled when 2027 registration opens.
// import { Widget } from '@typeform/embed-react';

function RegistrationandEligibility() {
  return (
    <div>
      <Seo
        title="Registration & Eligibility"
        path="/registration-and-eligibility"
        description="Who can take part in the International Research Olympiad and how registration works — eligibility for students aged 13–18 worldwide."
      />
      {/* Hero Section */}
      <div style={{ backgroundColor: "#f8f9fa", padding: "60px 0 50px 0" }}>
        <div className="container">
          <div style={{ maxWidth: "800px", margin: "0 auto", textAlign: "center" }}>
            <h1 style={{
              fontSize: "clamp(2rem, 4vw, 2.5rem)",
              fontWeight: "700",
              color: "#1a1a2e",
              marginBottom: "16px",
              letterSpacing: "-0.02em"
            }}>
              IRO Registration
            </h1>
            <p style={{
              fontSize: "1.1rem",
              color: "#555",
              lineHeight: "1.7"
            }}>
              Registration for the 2026 International Research Olympiad is now closed.
              The 2026 winners have been announced — view the results in the Winners Hub.
              Registration for the next cycle will open here in due course.
            </p>
          </div>
        </div>
      </div>

      {/* Closed-cycle CTA (replaces the live registration form) */}
      <div style={{ padding: "50px 0 80px 0", textAlign: "center" }}>
        <Link
          to="/winners-hub"
          style={{
            display: "inline-block",
            padding: "13px 28px",
            backgroundColor: "#004d99",
            color: "#fff",
            fontSize: "1rem",
            fontWeight: 600,
            borderRadius: "8px",
            textDecoration: "none",
            boxShadow: "0 4px 14px rgba(0,77,153,0.22)",
          }}
        >
          View the 2026 Results →
        </Link>
      </div>
    </div>
  );
}

export default RegistrationandEligibility;
